export const LANGUAGE_STORAGE_KEY = 'alprofessor-language';
export const SUPPORTED_LANGUAGES = ['ar', 'en'];

export const getPathLanguage = (pathname = '') => {
  const candidate = pathname.split('/')[1];
  return SUPPORTED_LANGUAGES.includes(candidate) ? candidate : null;
};

export const getStoredLanguage = () => {
  if (typeof window === 'undefined') return null;
  try {
    const saved = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return SUPPORTED_LANGUAGES.includes(saved) ? saved : null;
  } catch {
    return null;
  }
};

export const saveLanguage = (language) => {
  if (typeof window === 'undefined' || !SUPPORTED_LANGUAGES.includes(language)) return;
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Language still remains encoded in the URL when storage is unavailable.
  }
};

export const getInitialLanguage = () => {
  const pathLanguage = typeof window !== 'undefined' ? getPathLanguage(window.location.pathname) : null;
  return pathLanguage || getStoredLanguage() || 'ar';
};
